<p-tabView>
  <p-tabPanel header="Users">
    <boma-crud-table
      (changePageClicked)="handleChangePageClicked($event)"
      (itemDeleted)="handleUserDelete($event)"
      (createSubmit)="createItem()"
      (queryChanged)="search($event)"
      (viewSelection)="onView($event)"
      [allowDelete]="true"
      [createFormTemplateReference]="createFormTemplate"
      [data]="users$ | async"
      key="users"
      [displaySearchBar]="true"
      [headersValue]="'User'"
      [itemsPerPage]="perPage"
      [loaded]="loading$ | async"
      [paginationData]="paginationData$ | async"
      [searchBarPlaceHolder]="'Search Users'"
      [selectableColumns]="columns"
      [singularTerm]="'User'"
      [viewable]="true"
    >
    </boma-crud-table>
  </p-tabPanel>
  <p-tabPanel header="Notifications">
    <p-messages severity="info">
      <ng-template pTemplate>
        <span class="custom-message"
          >When enabling a notification here, a user will get notification for
          <strong>all locations</strong> in the company. If you wish for a user
          to only receive specific locations please define it per location by
          viewing the location or by creating a custom notification trigger
          under messaging.</span
        >
      </ng-template>
    </p-messages>
    <boma-user-notifications></boma-user-notifications>
  </p-tabPanel>
  <p-tabPanel header="Archived Users">
    <boma-archived-users></boma-archived-users>
  </p-tabPanel>
</p-tabView>

<ng-template #createFormTemplate>
  <ng-template pTemplate="header">
    <h4>
      {{
        (this.createUserIdentified$ | async)
          ? 'Link ' +
            ((this.createUserIdentified$ | async).firstName +
              ' ' +
              (this.createUserIdentified$ | async).surname)
          : 'Link Boma User'
      }}
    </h4>
  </ng-template>

  <!-- Loading Spinner when processing  -->
  <p-progressSpinner
    *ngIf="modalProcessing$ | async"
    class="m-3"
  ></p-progressSpinner>

  <!-- Find User By their Phone Number -->
  <div *ngIf="!(modalProcessing$ | async)">
    <form
      *ngIf="!(this.createUserIdentified$ | async)"
      [formGroup]="searchAccountFormGroup"
      style="width: 100%"
    >
      <h5>Link an existing Boma user to your organisation.</h5>
      <ul>
        <li>The user will have to have already be signed up with Boma</li>
        <li>
          You can only link the user by using either their email or phone number
        </li>
      </ul>
      <p>
        One you have added a user you will be able to capture additional details
        and assign roles or permissions for their account.
      </p>
      <p-messages></p-messages>
      <div class="text-left">
        <div class="formgrid grid">
          <div class="field col-12">
            <input
              formControlName="emailAddressOrPhoneNumber"
              pInputText
              placeholder="Phone Number / Email Address "
              required
              type="text"
            />
          </div>
          <div class="field col-12 md:col-6">
            <button
              (click)="inviteUser()"
              [disabled]="!searchAccountFormGroup.valid"
              class="p-button p-component p-button-secondary p-button-outlined"
              type="submit"
            >
              <span class="p-button-label">Invite</span>
            </button>
          </div>
          <div class="field col-12 md:col-6">
            <button
              (click)="onAccountSearch($event)"
              [disabled]="!searchAccountFormGroup.valid"
              class="p-button p-component p-button-primary"
              type="submit"
            >
              <span
                aria-hidden="true"
                class="p-button-icon p-button-icon-left pi pi-search"
              ></span
              ><span class="p-button-label">Search for Account</span>
            </button>
          </div>
        </div>
      </div>
    </form>

    <!-- User found - User Details form -->
    <form
      *ngIf="this.createUserIdentified$ | async"
      [formGroup]="createFormGroup"
      class="pb-2"
      style="height: 50vh"
    >
      <button
        (click)="this.createUserIdentified$ = null"
        class="p-button p-component p-button-outlined p-button-warning p-button-rounded"
        type="button"
      >
        <span
          aria-hidden="true"
          class="p-button-icon p-button-icon-left pi pi-angle-left"
        ></span
        ><span class="p-button-label"
          >Not {{ (this.createUserIdentified$ | async)?.firstName }}?</span
        >
      </button>

      <h5>
        {{ (this.createUserIdentified$ | async)?.firstName }}
        {{ (this.createUserIdentified$ | async)?.surname }}
      </h5>

      <hr />

      <div class="field grid">
        <label
          class="p-col-fixed"
          for="identificationNumber"
          style="width: 200px"
          >Identification Number</label
        >
        <div class="col">
          <input
            [ngStyle]="{ width: '100%' }"
            formControlName="identificationNumber"
            id="identificationNumber"
            pInputText
            type="text"
          />
        </div>
      </div>

      <div class="field grid">
        <label class="p-col-fixed" for="employeeNumber" style="width: 200px"
          >Employee Number</label
        >
        <div class="col">
          <input
            [ngStyle]="{ width: '100%' }"
            formControlName="employeeNumber"
            id="employeeNumber"
            pInputText
            type="text"
          />
        </div>
      </div>

      <div class="field grid">
        <label class="p-col-fixed" for="position" style="width: 200px"
          >Position</label
        >
        <div class="col">
          <input
            [ngStyle]="{ width: '100%' }"
            formControlName="position"
            id="position"
            pInputText
            type="text"
          />
        </div>
      </div>

      <div class="field grid">
        <label
          class="p-col-fixed"
          for="companyContactNumber"
          style="width: 200px"
          >Company Contact No.</label
        >
        <div class="col">
          <input
            [ngStyle]="{ width: '100%' }"
            formControlName="companyContactNumber"
            id="companyContactNumber"
            pInputText
            type="text"
          />
        </div>
      </div>

      <div class="field grid">
        <label
          class="p-col-fixed"
          for="personalContactNumber"
          style="width: 200px"
          >Personal Contact No.</label
        >
        <div class="col">
          <input
            [ngStyle]="{ width: '100%' }"
            formControlName="personalContactNumber"
            id="personalContactNumber"
            pInputText
            type="text"
          />
        </div>
      </div>

      <div class="field grid">
        <label class="p-col-fixed" for="department" style="width: 200px"
          >Department</label
        >
        <div class="col">
          <input
            [ngStyle]="{ width: '100%' }"
            formControlName="department"
            id="department"
            pInputText
            type="text"
          />
        </div>
      </div>

      <div class="field grid">
        <label class="p-col-fixed" for="notes" style="width: 200px"
          >Notes</label
        >
        <div class="col">
          <textarea
            [ngStyle]="{ width: '100%' }"
            formControlName="notes"
            id="notes"
            pInputText
            rows="4"
            type="text"
          ></textarea>
        </div>
      </div>
    </form>
  </div>

  <!-- <p-footer>
    <button
      pButton
      pRipple
      label="Cancel"
      icon="pi pi-times"
      class="p-button-text"
      (click)="this.showAddModal = false"
    ></button>
    <button
      pButton
      pRipple
      label="Save"
      icon="pi pi-check"
      class="p-button-text"
      [style.visibility]="this.createUserIdentified$ ? 'visible' : 'hidden'"
      [disabled]="!createFormGroup.valid || !this.createUserIdentified$"
      (click)="createItem()"
    ></button>
  </p-footer> -->
</ng-template>
